import { Component } from "react"

const characterSprite = require('../assets/character.png');

export default class Flyer extends Component<any> {
    render() {
        const width = this.props.body.bounds.max.x - this.props.body.bounds.min.x;
        const height = this.props.body.bounds.max.y - this.props.body.bounds.min.y;
        const x = this.props.body.position.x - width / 2;
        const y = this.props.body.position.y - height / 2;

        const rotation = this.props.body.velocity.y * 5;

        return (
            <img
                style={{
                    position: "absolute",
                    left: x,
                    top: y,
                    width: width,
                    height: height,
                    rotate: `${rotation}deg`
                }}
                alt="flyer"
                src={characterSprite} />
        );
    }
}